import React from 'react';
import { Container, Typography, List, ListItem } from '@mui/material';
import PageWrapper from '../components/PageWrapper';

const WhyThisSchool = () => {
    return (
        <PageWrapper configKey="why-mga" pageTitle="Why Choose MacGillis Global Academy">
            {(config) => (
                <Container maxWidth="md" sx={{ mt: 3, mb: 3 }}>
                    <Typography variant="h3" component="h2" gutterBottom>
                        Why Choose MacGillis Global Academy?
                    </Typography>
                    
                    <Typography sx={{ mb: 2 }}>
                        At MacGillis Global Academy, we redefine what it means to receive a truly personalized, high-quality, hybrid education.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        We are a grade 4-12 <strong>independent, accredited school</strong>, recognized by <strong>COGNIA</strong>. <strong>Our rigorous academic program is grounded in national education standards</strong> and designed to challenge, engage, and inspire students across every grade level.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        <strong>Our exceptional faculty</strong>—carefully selected from across the country—are experienced educators and subject matter experts. <strong>By offering our program live online, we're not bound by geography</strong>. This allows us to recruit and retain seasoned educators who deliver authentic, hybrid private-school instruction in real time—something most traditional brick-and-mortar schools simply cannot offer.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        At MacGillis, we <strong>focus on much more than just grades</strong>. We emphasize:
                    </Typography>

                    <List sx={{ listStyleType: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                            <Typography><strong>Deep academic and social-emotional growth</strong></Typography>
                        </ListItem>
                        <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                            <Typography><strong>Learning over testing</strong>—with rich, discussion-driven instruction</Typography>
                        </ListItem>
                        <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                            <Typography><strong>Development of essential life and career skills</strong>, including:</Typography>
                            <List sx={{ listStyleType: 'disc', pl: 4 }}>
                                <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                                    <Typography>Critical thinking</Typography>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                                    <Typography>Analytical reasoning</Typography>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                                    <Typography>Problem-solving</Typography>
                                </ListItem>
                                <ListItem sx={{ display: 'list-item', py: 0.5 }}>
                                    <Typography>Strong written and oral communication</Typography>
                                </ListItem>
                            </List>
                        </ListItem>
                    </List>

                    <Typography sx={{ mb: 2 }}>
                        We provide a <strong>safe, inclusive, and supportive environment</strong> where students are known, challenged, and cared for.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        With intentionally <strong>small class sizes</strong> (typically 10–16 students), we foster meaningful connections and maximize individualized support.
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        Most importantly, <strong>students are not held back</strong> by grade level constraints. We <strong>empower students to progress based on their academic skills, maturity, and motivation</strong>, offering access to advanced coursework as they're ready—regardless of age or traditional grade placement.
                    </Typography>
                </Container>
            )}
        </PageWrapper>
    );
};

export default WhyThisSchool; 